require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2011-12-09-node-js-interview-venturebeat.json") })
        }
      }, "path---articles-2011-12-09-node-js-interview-venturebeat");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2011-12-09-node-js-interview-venturebeat!./.cache/json/articles-2011-12-09-node-js-interview-venturebeat.json
// module id = 611
// module chunks = 231608221292675